/**
 * f12.1: the cycle workspace's way into the review screen (not a navigation
 * entry). Whether to render it is the SERVER's answer, never a state rule
 * re-derived here: the Finance/Admin workflow page may open every state, and
 * the scoped workspace renders it from f16.2's `review_access`, computed by
 * the same function the review GET uses to answer `200` or `404`.
 */

import { Link } from 'react-router-dom';
import { Presentation } from 'lucide-react';

export function ReviewLink({ cycleId, label = 'Review' }: { cycleId: string; label?: string }) {
  return (
    <Link className="btn btn-secondary" to={`/cycles/${encodeURIComponent(cycleId)}/review`}>
      <Presentation aria-hidden="true" /> {label}
    </Link>
  );
}
